import { byRanking } from "./byRanking";
import { getUrlPathSeo } from "../utils/getUrlPathSeo";
import { getUrlPathSeoSettings } from "../utils/getUrlPathSeoSettings";
import { getConfiguration } from "./configuration";
import { getTournamentsHighlightsImages } from "./getTournamentsHighlightsImages";

export function getTorneiInEvidenza(sports, currentFilter) {
	const conf = getConfiguration();
    const tie = conf.tie;
	
    const tournamentsRanking = {};
    tie.forEach((t, i) => tournamentsRanking[t] = i + 1);
    function byTournamentsRanking(a, b) {
		return tournamentsRanking[a.id] - tournamentsRanking[b.id];
    }
	const imagesMap = getTournamentsHighlightsImages();
    let inEvidenzaSports = [];
    const sportById = new Map();
    let tournamentsCount = 0;
    let tournamentsList = [];
    let tournamentsIds = [];
    const tournamentsMap = new Map();
    sports.forEach(sp => {
        if (sp.filters[currentFilter] !== undefined) {
            const categories = [];
            const tournaments = [];
            sp.categories.forEach(c => {
                const filteredTournaments = c.tournaments.filter(t => t.filters[currentFilter] !== undefined && tie.indexOf(t.id) !== -1);
                if (filteredTournaments.length > 0) {
                    const category = {
                        ...c,
                        tournaments: []
                    };
                    categories.push(category);
                    filteredTournaments.forEach(t => {
						const backgroundImage = imagesMap.get(t.uniqueId) || null;
                        const tournament = {
							backgroundImage,
							ranking: tournamentsRanking[t.id],
                            aggregate: t.aggregate,
                            categoryIcon: t.categoryIcon,
                            categoryRef: t.categoryRef,
                            descrizione: t.descrizione,
                            eventsCount: t.eventsCount,
                            eventsCountByFilter: t.eventsCountByFilter,
                            iconClass: t.iconClass,
                            id: t.id,
                            isLive: t.isLive,
                            sportRef: t.sportRef,
                            uniqueId: t.uniqueId,
                            urlPath: (sp.urlPath+'/'+t.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase(),
                            urlPathSeo: getUrlPathSeo(t),
                            urlPathSeoSettings: getUrlPathSeoSettings(t),
                            urlPathSuffix: `_${t.uniqueId}`
                        };
                        category.tournaments.push(tournament);
                        tournaments.push(tournament);
                        tournamentsList.push(tournament);
                        tournamentsIds.push(t.uniqueId);
                        tournamentsMap.set(t.uniqueId, tournament);
                        tournamentsCount++;
                    });
                }
            });
            if (tournaments.length > 0) {
                const competitions = tournaments.sort(byTournamentsRanking);
                const sport = {
                    id: sp.id,
                    iconClass: sp.iconClass,
                    descrizione: sp.descrizione,
                    categories,
                    competitions,
                };
                inEvidenzaSports.push(sport);
                sportById.set(sport.id, sport);
            }
        }
	});
	
	return {
        sportById,
		sportsList: inEvidenzaSports.sort(byRanking),
        tournamentsList: tournamentsList.sort(byTournamentsRanking),
		tournamentsIds,
        tournamentsMap,
		tournamentsCount
	}
}
